export function now() {
  return new Date();
}

export function nowMinusDays(days: number) {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
}

export function nowPlusDays(days: number) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
}
